'use strict';

var FaresSurchargeUploadErrorLogDirective = function FaresSurchargeUploadErrorLogDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-surcharge-upload-error-log.html'),
    controller: 'FaresSurchargeUploadErrorLogController'
  };
};
FaresSurchargeUploadErrorLogDirective.$inject = [];
module.exports = FaresSurchargeUploadErrorLogDirective;